export default __webpack_public_path__ + "26c91611ab326cef2f4382ecedaf5ff3.png";